import { DefaultQueryParams } from '@frontend/api-utils';
import { ObjectSelectInput, ObjectSelectProps } from '@frontend/components/basic-forms';
import { PlaylistClient } from '@frontend/playlist/api';
import { Playlist } from '@frontend/playlist/types';
import React, { useState } from 'react';

const ID = 'playlist-select';
export const PlaylistSelectV2 = (props: ObjectSelectProps<Playlist, DefaultQueryParams> ) => {
    const [v, cV] = useState<Playlist | null>(null);
    return (
        <ObjectSelectInput<Playlist, DefaultQueryParams>
            {...props}
            id={`${ID}${props.id && '-' + props.id}`}
            label={props.label || 'Playlist'}
            className={props.className}
            onChange={(v) => {
                props.onChange && props.onChange(v?.id || null);
                props.onChangeObject && props.onChangeObject(v);
                cV(v);
            }}
            required={props.required}
            queryParams={props.queryParams}
            value={v}
            idValue={props.value || v?.id}
            fetch={(arg) => PlaylistClient.fetchPlaylists({ ...arg, sort_field: 'name', sort_direction: 'asc' })}
            itemLabel={(p) => p.name}
        />
    );
};
